"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  StyledToast: true,
  toast: true,
  ToastContainer: true
};
exports.StyledToast = void 0;
Object.defineProperty(exports, "ToastContainer", {
  enumerable: true,
  get: function () {
    return _ToastContainer.default;
  }
});
Object.defineProperty(exports, "toast", {
  enumerable: true,
  get: function () {
    return _reactToastify.toast;
  }
});

var ToastStyles = _interopRequireWildcard(require("./Toast.styles"));

var _reactToastify = require("react-toastify");

var _Toast2 = require("./Toast.utils");

Object.keys(_Toast2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Toast2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Toast2[key];
    }
  });
});

var _ToastContainer = _interopRequireDefault(require("./ToastContainer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledToast = ToastStyles;
exports.StyledToast = StyledToast;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTdHlsZWRUb2FzdCIsIlRvYXN0U3R5bGVzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVG9hc3QvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgVG9hc3RTdHlsZXMgZnJvbSAnLi9Ub2FzdC5zdHlsZXMnXG5cbmV4cG9ydCB7IHRvYXN0IH0gZnJvbSAncmVhY3QtdG9hc3RpZnknXG5leHBvcnQgKiBmcm9tICcuL1RvYXN0LnV0aWxzJ1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBUb2FzdENvbnRhaW5lciB9IGZyb20gJy4vVG9hc3RDb250YWluZXInXG5leHBvcnQgY29uc3QgU3R5bGVkVG9hc3QgPSBUb2FzdFN0eWxlc1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBQ0E7O0FBQUE7RUFBQTtFQUFBO0VBQUE7RUFBQTtJQUFBO0lBQUE7TUFBQTtJQUFBO0VBQUE7QUFBQTs7QUFDQTs7Ozs7O0FBQ08sTUFBTUEsV0FBVyxHQUFHQyxXQUFwQiJ9